import React, { useEffect, useState, useRef } from "react";
import { Accordion } from "react-bootstrap";
import "./OpalContextualActivity.css";
import TauriLoader2 from "../../../TauriLoader2/TauriLoader2";
import TauriImage from "../../../TauriImage/TauriImage";
import TauriDocuments from "../../../TauriDocuments/TauriDocuments";
import { addRecord, deleteRecord, getAll, getNextId, getRecordById, updateRecord } from "../../../../localDB";
import { FileStatus, statusMapping } from "../../../../visualizations/visualizations";
import OpalAlertModal from "../../../OpalAlertModal/OpalAlertModal";

const OpalContextualActivity = ({ section, id, session }) => {
    const [loading, setIsLoading] = useState();
    const [showMessage, setShowMessage] = useState(false);
    const [sessionAction, setSessionAction] = useState(null);

    return (
        <div className="opal-contextual mb-2 d-none d-md-block">
            <Accordion defaultActiveKey="0" alwaysOpen>
                <Accordion.Item eventKey="0">
                    <Accordion.Header className="p-0 mb-2">
                        <div className="header-container">
                            <div className="header-left">
                                <TauriImage localImage={section?.icon} className="tat-icon me-2" alt="icon" />
                                <span className="header-title">{section?.header?.toUpperCase()}</span>
                            </div>
                        </div>
                    </Accordion.Header>

                    <Accordion.Body className="py-0 px-0">
                        {loading ? (
                            <TauriLoader2 width="2.5rem" height="2.5rem" borderwidth="0.35rem" color="#1D5D9B" />
                        ) : (
                            <div>{session?.Remarks}</div>

                        )}
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
            {sessionAction && (
                <OpalAlertModal
                    show={showMessage}
                    onHide={() => setShowMessage(false)}
                    title={sessionAction.title}
                    bodyText={sessionAction.bodyText}
                    onConfirm={sessionAction.onConfirm}
                    confirmButtonText={sessionAction.confirmText}
                    cancelButtonText=""
                    modalType="message"
                />
            )}
        </div>
    );
};

export default OpalContextualActivity;
